import DialogName from '../constants/DialogName';
import hideDialog from './hideDialog';

export default function hideReleaseFeatureConfirm() {
  return hideDialog(DialogName.RELEASE_FEATURE_CONFIRM)();
}
